import Api from '../Api';

import { url } from './config';
import { PaymentMethod } from './model';

const api = new Api<PaymentMethod>(url);

export default api;
